export const DASHBOARD_SECTION_SX = {
  borderRadius: '16px',
  mt: 3,
  flexGrow: 0,
  boxShadow: 'none',
};

export const DASHBOARD_SECTION_CONTENT_SX = {
  p: 2,
  height: 'auto',
};
